exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._7PZ8g37CW_Ffm6eVNGhUH {\n  position: fixed;\n  width: 27px;\n  height: 192px;\n  background: #ffffff;\n  border-top: solid 1px #1f3568;\n  border-bottom: solid 1px #1f3568;\n  border-right: solid 1px #1f3568;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n  -webkit-writing-mode: vertical-rl;\n      -ms-writing-mode: tb-rl;\n          writing-mode: vertical-rl;\n  text-orientation: mixed;\n  text-transform: uppercase;\n  text-align: center;\n  font-size: 14px;\n  cursor: pointer;\n  z-index: 1000;\n}\n", ""]);

// exports
exports.locals = {
	"banner": "_7PZ8g37CW_Ffm6eVNGhUH"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/views/components/Common/DrawerPanel/DrawerPanel.css
// module id = 9775
// module chunks = 23